<ta-link
  [taRouterLink]="subsectionLink"
  [fragment]="header.fragment || (header.label | lowercase).split(' ').join('-')"
>
  <li
    class="subsection-header pl--4 pv--3"
    (mouseenter)="hover = true"
    (mouseleave)="hover = false"
    [class.hover]="hover && !active"
    [class.active]="active"
  >
    {{ header.label }}
  </li>
</ta-link>

<div *ngIf="!isLast" class="border--bottom mh--4"></div>
